import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_PROGRAMANDBRANDREQUEST,
  CREATE_PROGRAMANDBRANDREQUEST,
  FETCH_PROGRAMANDBRANDREQUEST,
  FETCH_PROGRAMANDBRANDREQUEST_LIST,
  UPDATE_PROGRAMANDBRANDREQUEST,
} from './programAndBrandRequest.actions';
import { ProgramAndBrandRequest, ProgramAndBrandRequestState } from './programAndBrandRequest.types';

const getInitialProgramAndBrandRequestState = ():ProgramAndBrandRequest  => ({});

const initialState: ProgramAndBrandRequestState = {
  errorMessage: '',
  item: getInitialProgramAndBrandRequestState(),
  items: [],
  loading: false,
  totalItems: 0,
};

export default (state: ProgramAndBrandRequestState = initialState, action: AppAction): ProgramAndBrandRequestState => {
  switch (action.type) {
    case REQUEST(FETCH_PROGRAMANDBRANDREQUEST_LIST):
    case REQUEST(CREATE_PROGRAMANDBRANDREQUEST):
    case REQUEST(FETCH_PROGRAMANDBRANDREQUEST):
    case REQUEST(UPDATE_PROGRAMANDBRANDREQUEST):
      return { ...state, loading: true };
    case SUCCESS(FETCH_PROGRAMANDBRANDREQUEST_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_PROGRAMANDBRANDREQUEST_LIST):
    case FAILURE(CREATE_PROGRAMANDBRANDREQUEST):
    case FAILURE(FETCH_PROGRAMANDBRANDREQUEST):
    case FAILURE(UPDATE_PROGRAMANDBRANDREQUEST):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_PROGRAMANDBRANDREQUEST):
    case SUCCESS(FETCH_PROGRAMANDBRANDREQUEST):
    case SUCCESS(UPDATE_PROGRAMANDBRANDREQUEST):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_PROGRAMANDBRANDREQUEST:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
